import { useEffect } from 'react';

import { useRoute } from 'hooks/navigation/use-route';
import { usePrevious } from 'hooks/use-previous';
import { useCRMEventsContext } from 'state/crm-events';
import { useStoreContext } from 'state/store';

// Only used for react-router and WEB
export default function useLogPageView() {
  const { pathname } = useRoute();
  const previousPathname = usePrevious(pathname);
  const { logPageView } = useCRMEventsContext();
  const { store } = useStoreContext();

  useEffect(() => {
    if (previousPathname !== pathname) {
      logPageView(pathname, store);
    }
  }, [logPageView, pathname, store, previousPathname]);
}
